import styled from 'styled-components';

export const GoSafeInfoLoaderWrapDiv = styled.div(
  props => `
    display:flex;
    width:100%;
    background-color:${props.theme.colors.goWhite.base};
    border-radius:${props.theme.misc.borderRadius.large};
    padding:${props.theme.spacing.large}

  `,
);

export const GoSafeInfoImgLoader = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    background-color:${props.theme.colors.goBrandBlue.medium};
    border-radius:${props.theme.misc.borderRadius.small};
    width: 4rem;
    height:4rem;
  `,
);

export const GoSafeInfoContextWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    padding-left: ${props.theme.spacing.large};
    width: 100%;
  `,
);

export const GoSafeInfoSmallTextLoader = styled.div(
  props => `

    background-color:${props.theme.colors.goBrandBlue.medium};
    border-radius:${props.theme.misc.borderRadius.small};
    width: 25%;
    height:1.3rem;
    margin-bottom :${props.theme.spacing.large};
  
  `,
);

export const GoSafeInfoLargeTextLoader = styled.div(
  props => `
  
    background-color:${props.theme.colors.goBrandBlue.medium};
    border-radius:${props.theme.misc.borderRadius.small};
    width: 70%;
    height:1.3rem;
  
  `,
);
